import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-fee-daily-closing',
  templateUrl: './fee-daily-closing.component.html',
  styleUrls: ['./fee-daily-closing.component.css']
})
export class FeeDailyClosingComponent implements OnInit {

  constructor(private route: ActivatedRoute,private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
   SearchModel = {
    StudentID: 0,
    SectionID: 0,
    SessionID: 0,
    ClassID: 0,
    StudentNo: '',
    FromDate: moment(new Date()).format("DD-MMM-YYYY"),
    ToDate: '',
    Print:'',
    CreatedBy: 0,
    TransID:0,
    Narration:"",
    IsPost:false,
}
Submitted = false;
loadingSearch = false;

FeeDailyList:any;
PaymentModeList:any;
TotalSum = 0;
AccName="";
GetFeeDailyClosing  () {

  this.Submitted = true;
    if (!this.ValidateDropdownSearch()) {
      this.SearchModel.FromDate=moment(new Date(this.SearchModel.FromDate)).format("DD-MMM-YYYY");
      this.loadingSearch = true;
          this.spinnerService.show();
        this.accService.GetFeeDailyClosing(JSON.stringify(this.SearchModel)).subscribe( (data)=> {
          this.SearchModel.TransID = data.TransID;
          this.SearchModel.Narration = data.Narration;
              
          this.loadingSearch = false;
          this.Submitted = false;
           this.spinnerService.hide();




            if (data.webResponse.Status) {
              this.FeeDailyList = data.FeeDailyList;
              this.PaymentModeList = data.PaymentModeList;
              // this.search(this.FeeDailyList);
              this.TotalSum = 0;
                for (var i = 0; i < this.FeeDailyList.length; i++) {

                  this.TotalSum = this.TotalSum + this.FeeDailyList[i].Amount
                }
            }
            this.globalHelper.CheckActionStatus(data);
        });
    }

};
SelectAlertMsg = '';
loadingSave = false;
SubmittedSave = false;
PaymentModeAlert ="";
SaveFeeDailyClosing  () {
 
  this.Submitted = true;
    if (this.SearchModel.TransID > 0) {
        var r = confirm("Are you sure you want to Re-Post Fee ");
    }
    else {
        
        r = true;
    }

    if (r == true) {
    
        var isLockOther = true;
        var isLock = true;
        var CisLock = true;
      
        for (var i = 0; i < this.PaymentModeList.length; i++) {
            if (this.PaymentModeList[i].AccID == 0) {
                isLock = false;
                
                break;
            }
            if (this.PaymentModeList[i].OtherIncomeAmount> 0 && this.PaymentModeList[i].OtherIncomeAccID == 0) {
                isLockOther = false;
                break;
            }
        }

        for (i = 0; i < this.FeeDailyList.length; i++) {
            if (this.FeeDailyList[i].AccID == 0) {
                 CisLock = false;
                break;
            }
        }

       

        if (isLockOther) {
        
          this.Submitted = false;
            if (CisLock) {
             
                if (isLock) {
                
                  this.SubmittedSave = true;
                    if (!this.ValidateDropdownSave()) {
                    
                        var result = true;
                        if (this.SearchModel.IsPost) {
                            var result = confirm("Are you sure you want to Post?");
                        }
                        if (result) {

                          this.SelectAlertMsg = '';
                          this.loadingSave = true;
                              this.spinnerService.show();
                            this.accService.SaveFeeDailyClosing(JSON.stringify(this.SearchModel), JSON.stringify(this.FeeDailyList), JSON.stringify(this.PaymentModeList)).subscribe( (response)=> {

                                  setTimeout( ()=> {
                                   this.spinnerService.hide();
                                  this.loadingSave = false;
                                }, 10);
                              this.SubmittedSave = false;
                              this.GetFeeDailyClosing();
                               this.globalHelper. CheckActionStatus(response);

                            });
                        }

                    }
                } else {

                  this.PaymentModeAlert = "Please lock All Payment Mode Account ";
                }
            } else {

              this.PaymentModeAlert = "Please  Set Fee Component  Account ";
            }
        } else {

          this.PaymentModeAlert = "Please  Set Other Income  Account ";
        }
    }
}

 ValidateDropdownSave() {
    return this.SearchModel.Narration == ''


};
















AcademicSessionList:any;
GetAcademicSession  () {
      this.spinnerService.show();
    this.lookupService.GetLookupsList('AcademicSession', '').subscribe( (data)=> {
      this.AcademicSessionList = data.LookupItems;
       this.spinnerService.hide();
    });
};
 ValidateDropdownSearch() {
    return this.SearchModel.FromDate == '';

};




loadingDownload = false;
FilePath:any;
GetFeeDailyClosingDownload  () {

  this.Submitted = true;
    if (!this.ValidateDropdownSearch()) {
      
      this.loadingDownload = true;
      this.SearchModel.Print = 'P';
          this.spinnerService.show();
        this.accService.GetFeeDailyClosing(JSON.stringify(this.SearchModel)).subscribe( (data)=> {
              this.globalHelper.CheckActionStatus(data);
          this.loadingDownload = false;
          this.Submitted = false;
           this.spinnerService.hide();
            if (data.webResponse.Status) {
               
              this.FilePath = data.FilePath;
                window.location = data.FilePath;
              
            }
          this.loadingDownload = false;
        });
    }

};
Print  () {

    var divContents = document.getElementById("dvContainer").innerHTML;
    divContents = divContents.replace('no record found', '');
    var printWindow = window.open('', '', 'height=400,width=800');
    printWindow.document.write('<html><head><title>Voucher Receipt </title>');
    printWindow.document.write('<style type="text/css">');
    printWindow.document.write('.t1{ border-top: 1px solid black;  border-left: 1px solid black;white-space:nowrap;font-family:Calibri;font-size:10px} .t2 { border-right: 1px solid black; border-bottom: 1px solid black;}.t3 { border-right: 1px solid black;border-bottom: 1px solid black; }');
    printWindow.document.write('</style>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(divContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();

}
onSelectName  ($item, item) {
    item.OtherIncomeAccName = $item.AccName;
  
    item.OtherIncomeAccID = $item.AccID;
}
AccountList:any;
GetAccount  () {
    this.lookupService.GetLookupsList('Acc', '').subscribe( (data)=> {
      this.AccountList = data.LookupItems;
      this.AccountList.splice(0, 1);
    });
}





  PrintDate="";
  TransDate:any;
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
     
      this.TransDate =  params['TransDate'];
     
    });
    
    if( this.TransDate!=undefined){


      this.SearchModel.FromDate=this.TransDate;
     
      this.GetFeeDailyClosing();
     }
    this.PrintDate = moment(new Date()).format("DD-MMM-YYYY")
    this.GetAcademicSession();
    this.GetAccount();
  
  }

}
